

import './search-box.styles.css'


const SearchBox = ({className, placeholder, onChangeHandler}) => (
    
     
      
        <div>
      <input className ={`search-box ${className}`} type='search' placeholder={placeholder}  
        onChange = {onChangeHandler}/>

</div> //render return
)


export default SearchBox;


    


 